<agpr-dialog-container
    [id]="id"
    heading="Discover.distribution.saveAsTemplate.heading"
    [modal]="true"
    [draggable]="false"
    [contentPadding]="false"
    (close)="cancel()"
>
    <div
        class="agpr-distributionSaveTemplateDialog-content"
        role="radiogroup"
        [attr.aria-label]="'Discover.distribution.saveAsTemplate.saveDialogOptions' | localize"
    >
        <div class="agpr-distributionSaveTemplateDialog-inputGroup">
            <agpr-radio
                [id]="id + '_createRadio'"
                class="agpr-distributionSaveTemplateDialog-radio"
                [value]="saveTemplateState.NEW"
                [(ngModel)]="saveType"
                (ngModelChange)="validate()"
                name="save_options"
                label="Discover.distribution.saveAsTemplate.saveAsNewLabel"
                hiddenLabel="Discover.distribution.saveAsTemplate.saveAsNewLabel"
            ></agpr-radio>
            <div class="agpr-distributionSaveTemplateDialog-inputGroupContent">
                <agpr-text-input
                    [id]="id + '_newStyleNameInput'"
                    class='agpr-input agpr-distributionSaveTemplateDialog-newNameInput'
                    ariaLabel="Discover.distribution.saveAsTemplate.saveAsNewLabel.placeholder"
                    [(ngModel)]="newTemplateName"
                    (ngModelChange)="validate()"
                    [placeholder]="'Discover.distribution.saveAsTemplate.saveAsNewLabel.placeholder' | localize"
                    [maxLength]="64"
                    [bottomMargin]="false"
                    [disabled]="saveType === saveTemplateState.UPDATE"
                ></agpr-text-input>
                <agpr-form-message *ngIf="nameRequired">
                    {{ 'Discover.distribution.saveAsTemplate.saveAsNewLabel.nameRequired' | localize }}
                </agpr-form-message>
            </div>
        </div>

        <div class="agpr-distributionSaveTemplateDialog-inputGroup">
            <agpr-radio
                [id]="id + '_updateRadio'"
                class="agpr-distributionSaveTemplateDialog-radio"
                [value]="saveTemplateState.UPDATE"
                [(ngModel)]="saveType"
                (ngModelChange)="validate()"
                name="save_options"
                label="Discover.distribution.saveAsTemplate.updateExisting"
                hiddenLabel="Discover.distribution.saveAsTemplate.updateExisting"
            ></agpr-radio>
            <div class="agpr-inputGroupRow agpr-distributionSaveTemplateDialog-inputGroupContent">
                <agpr-dropdown
                    [id]="id + '_updateDropdown'"
                    class="agpr-inputGroupRow-dropdown"
                    placeholder="Discover.distribution.saveAsTemplate.updateExisting.placeholder"
                    [disabled]="saveType === saveTemplateState.NEW"
                    [(ngModel)]="existingDistributionTemplateDropdown"
                    (ngModelChange)="validate()"
                    [options]="distributionTemplateListItems"
                    optionLabel="name"
                    ariaLabel="Discover.distribution.saveAsTemplate.updateExisting.placeholder"
                ></agpr-dropdown>
                <agpr-button
                    [id]="id + '_manageTemplates'"
                    class="agpr-inputGroupRow-buttons"
                    icon="fa-regular fa-duotone fa-gear"
                    tooltip="Discover.distribution.manageTemplate"
                    [style]="buttonTypes.icon"
                    (click)="openManageTemplatesDialog()"
                ></agpr-button>
            </div>
        </div>
    </div>

    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="Core.button.cancel"
            [style]="buttonTypes.secondary"
            (click)="closeDialog();"
        ></agpr-button>
    </ng-template>

    <ng-template #footerRight>
        @if (saveType === saveTemplateState.NEW) {
            <agpr-button
                [id]="id + '_createButton'"
                label="Discover.distribution.saveAsTemplate.create"
                [style]="buttonTypes.primary"
                (click)="create()"
                [disabled]="!formValid"
            ></agpr-button>
        } @else if (saveType === saveTemplateState.UPDATE) {
            <agpr-button
                [id]="id + '_updateButton'"
                label="Discover.distribution.saveAsTemplate.update"
                [style]="buttonTypes.primary"
                (click)="update()"
                [disabled]="!formValid"
            ></agpr-button>
        }
    </ng-template>
</agpr-dialog-container>
